"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PrivacyCaret_1 = __importDefault(require("./PrivacyCaret"));
const PrivacyCheckbox_1 = __importDefault(require("./PrivacyCheckbox"));
const usePrivacyText_1 = __importDefault(require("./usePrivacyText"));
const PrivacyGroup = ({ description, category, categoriesSelected, setCategoriesSelected, title, tools }) => {
    const isSelected = categoriesSelected.includes(category);
    const [expanded, setExpanded] = react_1.default.useState(false);
    const text = (0, usePrivacyText_1.default)();
    const handleCheckboxChange = react_1.default.useCallback((checked) => {
        if (!checked) {
            setCategoriesSelected(categoriesSelected.filter((d) => d !== category));
        }
        else {
            setCategoriesSelected([...categoriesSelected, category]);
        }
    }, [category, categoriesSelected, setCategoriesSelected]);
    const handleExpandToggleClick = react_1.default.useCallback(() => {
        setExpanded(!expanded);
    }, [expanded]);
    return (react_1.default.createElement("div", { className: "privacy__group" },
        react_1.default.createElement("div", { className: "privacy__group__wrapper" },
            react_1.default.createElement(PrivacyCheckbox_1.default, { checked: isSelected, disabled: !(tools === null || tools === void 0 ? void 0 : tools.length), onChange: handleCheckboxChange }),
            react_1.default.createElement("div", { className: "privacy__group__inner" },
                (tools === null || tools === void 0 ? void 0 : tools.length) ? (react_1.default.createElement("button", { className: "privacy__group__header", onClick: handleExpandToggleClick, role: "button" },
                    react_1.default.createElement("label", { className: "privacy__text privacy__group__heading" }, title),
                    react_1.default.createElement(PrivacyCaret_1.default, { expanded: expanded }))) : (react_1.default.createElement("div", { className: "privacy__group__header" },
                    react_1.default.createElement("label", { className: "privacy__text privacy__group__heading" }, title))),
                react_1.default.createElement("p", { className: "privacy__text privacy__group__description" }, description),
                expanded && (tools === null || tools === void 0 ? void 0 : tools.length) && (react_1.default.createElement("div", { className: "privacy__group__content" }, tools === null || tools === void 0 ? void 0 : tools.map((tool) => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "privacy__text privacy__text--bold" }, tool.provider),
                    react_1.default.createElement("div", { className: "privacy__group__table" },
                        react_1.default.createElement("div", { className: "privacy__text privacy__text--small" },
                            react_1.default.createElement("strong", null, text.purpose),
                            " ",
                            tool.description),
                        react_1.default.createElement("div", { className: "privacy__text privacy__text--small" },
                            react_1.default.createElement("strong", null, text.duration),
                            " ",
                            tool.duration)))))))))));
};
exports.default = PrivacyGroup;
